export const GET_ALL_MEMBER_TIERS_REQUEST = 'GET_ALL_MEMBER_TIERS_REQUEST';
export const GET_ALL_MEMBER_TIERS_SUCCESS = 'GET_ALL_MEMBER_TIERS_SUCCESS';
export const GET_ALL_MEMBER_TIERS_FAILED = 'GET_ALL_MEMBER_TIERS_FAILED';

export const GET_MEMBER_TIER_REQUEST = 'GET_MEMBER_TIER_REQUEST';
export const GET_MEMBER_TIER_SUCCESS = 'GET_MEMBER_TIER_SUCCESS';
export const GET_MEMBER_TIER_FAILED = 'GET_MEMBER_TIER_FAILED';

export const CLEAR_ALL_MEMBER_TIERS_REQUEST = 'CLEAR_ALL_MEMBER_TIERS_REQUEST';
export const CLEAR_ALL_MEMBER_TIERS_SUCCESS = 'CLEAR_ALL_MEMBER_TIERS_SUCCESS';
export const CLEAR_ALL_MEMBER_TIERS_FAILED = 'CLEAR_ALL_MEMBER_TIERS_FAILED';

export const CLEAR_ACTIVE_MEMBER_TIER_REQUEST = 'CLEAR_ACTIVE_MEMBER_TIER_REQUEST';
export const CLEAR_ACTIVE_MEMBER_TIER_SUCCESS = 'CLEAR_ACTIVE_MEMBER_TIER_SUCCESS';
export const CLEAR_ACTIVE_MEMBER_TIER_FAILED = 'CLEAR_ACTIVE_MEMBER_TIER_FAILED';
